import type { ExperienceState } from "../types/exhibition";

export function stateForChapter(chapterIndex: number): ExperienceState {
  if (chapterIndex <= 0 || chapterIndex >= 6) return "attract";
  if (chapterIndex === 4) return "catalog";
  if (chapterIndex === 3 || chapterIndex === 5) return "hero";
  return "story";
}

export function normalizedChapterProgress(
  normalized: number,
  chapterCount: number,
): Readonly<{ chapterIndex: number; chapterProgress: number }> {
  const safeProgress = Math.min(1, Math.max(0, normalized));
  const scaled = safeProgress * chapterCount;
  const chapterIndex = Math.min(chapterCount - 1, Math.floor(scaled + 0.00001));
  return {
    chapterIndex,
    chapterProgress: Math.min(1, scaled - chapterIndex),
  };
}

export function wrapChapter(chapterIndex: number, chapterCount: number): number {
  return ((chapterIndex % chapterCount) + chapterCount) % chapterCount;
}
